let publicTaggingMode = (
    process.env.REACT_APP_ALLOW_PUBLIC_TAGGING &&
    process.env.REACT_APP_ALLOW_PUBLIC_TAGGING.toLowerCase() === "true"
);

let Config = {
    // Static - build-time
    buildVersion: process.env.REACT_APP_BUILD_VERSION || "",
    servers: process.env.REACT_APP_SERVERS,
    isProduction: process.env.NODE_ENV !== "development",
    allowPublicTagging: publicTaggingMode,
    showAllInLevel2: publicTaggingMode, //FIXME Not the most logical - would like a better way of handling this in L2

    // Configurable
    displayQuad: loadDisplayQuad(),
    displayTimeline: loadDisplayTimeline(),
    language: loadLanguage(),
    possessionTracking: loadPossessionTracking(),
    networkConfiguration: loadNetworkConfig(),
    hlsMinEnabled: loadHlsMinEnabled(),
};

if (!Config.servers) {
    if (Config.isProduction) {
        console.error("Server built with no servers enabled");
    } else {
        throw new Error("No servers included in build-time configuration");
    }
}

function loadPossessionTracking () {
    let value = localStorage.getItem("possessionTracking");
    return value === null ? false : value === "true";
}

function loadDisplayQuad () {
    let value = localStorage.getItem("displayQuad");
    return value === null ? true : value === "true";
}

function loadDisplayTimeline () {
    let value = localStorage.getItem("displayTimeline");
    return value === null ? true : value === "true";
}

function loadLanguage () {
    let value = localStorage.getItem("language");
    return value === null ?
        process.env.REACT_APP_LANGUAGE || "se" :
        value;
}

function loadHlsMinEnabled () {
    let value = localStorage.getItem("hlsMinEnabled");
    // With public tagging mode enabled, the default is set to false because not all storage formats are supported
    const fallback = !publicTaggingMode;
    return value === null ? fallback : value === "true";
}

function loadNetworkConfig () {
    let value = localStorage.getItem("networkConfiguration");
    const fallback = publicTaggingMode ? "public" : "tagging";
    return [ "tagging", "tagging-ip", "public", "ssh-tunnel", "telenor-internal" ].includes(value) ? value : fallback;
}

export function setConfigVariable (key, value) {
    Config[key] = value;
    localStorage.setItem(key, value);
}

export function setConfig (config) {
    for (let key in config) {
        if (config.hasOwnProperty(key)) setConfigVariable(key, config[key]);
    }
}

//TODO Not a great solution once moved to config menu.
//Could use forceUpdate on entire react tree when changing config, but a bit ugly
//Either way, somehow need to refresh all the views when modifying configuration
//Alternatively add redux - adding redux could reduce complexity of LiveStream class as well

export default Config;



// WEBPACK FOOTER //
// ./src/js/include/Config.js